export default "__VITE_ASSET__CeGNGRVr__"